import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, ViewChild, ElementRef, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { BrMaskerModule } from 'br-mask';
import { TooltipModule } from 'ng2-tooltip-directive';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCDatePickerModule } from '@wlp/ui-c-date-picker';

let UiCFilterReceiptComponent = class UiCFilterReceiptComponent {
    constructor() {
        this.searchbarEvent = new EventEmitter();
        this.datePickerDateInitialEvent = new EventEmitter();
        this.datePickerDateEndEvent = new EventEmitter();
        this.datePickerButtonEvent = new EventEmitter();
        this.btnDayEvent = new EventEmitter();
    }
    findBySearchbar(event) {
        this.searchbarEvent.emit(event.detail.value);
    }
    selectDatePicker(typeDate, event) {
        if (typeDate === "initialDate") {
            this.datePickerDateInitialEvent.emit(event);
        }
        if (typeDate === "endDate") {
            this.datePickerDateEndEvent.emit(event);
        }
    }
    findByDatePicker(event) {
        this.datePickerButtonEvent.emit(event);
        this.resetBtnFilters();
    }
    findByBtnDay(event, numberDay) {
        this.resetBtnFilters();
        const element = event.target;
        element.classList.add('primary');
        this.btnDayEvent.emit(numberDay);
    }
    resetBtnFilters() {
        const btnsHolder = this.btnList.nativeElement;
        const btns = btnsHolder.querySelectorAll('.btn-filter');
        btns.forEach((btn) => btn.classList.remove('primary'));
    }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCFilterReceiptComponent.prototype, "searchbarValue", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCFilterReceiptComponent.prototype, "initialDate", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCFilterReceiptComponent.prototype, "endDate", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], UiCFilterReceiptComponent.prototype, "btnDay", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCFilterReceiptComponent.prototype, "searchbarEvent", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCFilterReceiptComponent.prototype, "datePickerDateInitialEvent", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCFilterReceiptComponent.prototype, "datePickerDateEndEvent", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCFilterReceiptComponent.prototype, "datePickerButtonEvent", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCFilterReceiptComponent.prototype, "btnDayEvent", void 0);
__decorate([
    ViewChild(`btnList`, { static: false }),
    __metadata("design:type", ElementRef)
], UiCFilterReceiptComponent.prototype, "btnList", void 0);
UiCFilterReceiptComponent = __decorate([
    Component({
        selector: 'ui-c-filter-receipt',
        template: "<div class=\"filter-form\">\n <ion-grid id=\"toobox-filter\" class=\"w-100 mt-2\">\n  <ion-row class=\"row flex-row align-content-between\">\n    <ion-col class=\"pr-3\" size=\"12\">\n      <ion-row size=\"12\" class=\"row flex-row justify-content-between align-items-center px-3\">\n        <ion-col size=\"3\">\n          <ion-grid>\n            <ion-row class=\"row flex-row justify-content-between align-items-center\">\n              <ion-col>\n                <ion-searchbar #searchbar\n                               (ionChange)=\"findBySearchbar($event)\"\n                               class=\"filter-size\"\n                               placeholder=\"{{'CASH_OUT.EXTRACT_RECEIPT.PLACEHOLDER' | wlpTranslate}}\">\n                </ion-searchbar>\n              </ion-col>\n            </ion-row>\n          </ion-grid>\n        </ion-col>\n         <ion-col size=\"5\">\n                  <ion-grid size=\"12\">\n                    <ion-row size=\"12\" class=\"row flex-row align-content-around align-items-center px-2\" size=\"12\">\n                      <ion-col size=\"5\">\n                        <div class=\"cal-input-control\">\n                          <ui-c-date-picker\n                                  [selectedDate]=\"initialDate\"\n                                  (dateSelected)=\"selectDatePicker('initialDate', $event)\"\n                                  [inputValue]=\"'CASH_OUT.EXTRACT_RECEIPT.FILTERS.FROM' | wlpTranslate\">\n                          </ui-c-date-picker>\n                        </div>\n                      </ion-col>\n                      <ion-col size=\"4\">\n                        <div class=\"cal-input-control\">\n                          <ui-c-date-picker\n                                  [selectedDate]=\"endDate\"\n                                  (dateSelected)=\"selectDatePicker('endDate', $event)\"\n                                  [inputValue]=\"'CASH_OUT.EXTRACT_RECEIPT.FILTERS.TO' | wlpTranslate\">\n                          </ui-c-date-picker>\n                        </div>\n                      </ion-col>\n                      <ion-col size=\"4\">\n                        <ion-button\n                                class=\"w-75 btn-filter primary\"\n                                shape=\"round\"\n                                expand=\"block\"\n                                (click)=\"findByDatePicker($event)\">\n                          {{'CASH_OUT.EXTRACT_RECEIPT.SEARCH_DATA' | wlpTranslate}}\n                        </ion-button>\n                      </ion-col>\n                    </ion-row>\n                  </ion-grid>\n                </ion-col>\n          <ion-col class=\"col-btn-selects\" size=\"3\">\n          <div #btnList class=\"row flex-row justify-content-between align-items-center\">\n            <div class=\"col-4 px-0\">\n              <ion-button\n                      class=\"btn-filter mx-auto primary\"\n                      (click)=\"findByBtnDay($event, 7)\">\n                {{'CASH_OUT.EXTRACT_RECEIPT.SEVEN_DAYS' | wlpTranslate}}</ion-button>\n            </div>\n            <div class=\"col-4 px-0\">\n              <ion-button\n                      class=\"btn-filter mx-auto\"\n                      (click)=\"findByBtnDay($event, 15)\">\n                {{'CASH_OUT.EXTRACT_RECEIPT.FIFTEEN_DAYS' | wlpTranslate}}</ion-button>\n            </div>\n            <div class=\"col-4 px-0\">\n              <ion-button\n                      class=\"btn-filter mx-auto\"\n                      (click)=\"findByBtnDay($event,30)\">\n                {{'CASH_OUT.EXTRACT_RECEIPT.THIRTY_DAYS' | wlpTranslate}}</ion-button>\n            </div>\n          </div>\n        </ion-col>\n\n      </ion-row>\n    </ion-col>\n\n  </ion-row>\n</ion-grid>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCFilterReceiptComponent);

let UiCFilterReceiptModule = class UiCFilterReceiptModule {
};
UiCFilterReceiptModule = __decorate([
    NgModule({
        declarations: [UiCFilterReceiptComponent],
        imports: [
            CommonModule,
            IonicModule,
            ReactiveFormsModule,
            TooltipModule,
            BrMaskerModule,
            UiCDatePickerModule,
            UiBsTranslateModule,
        ],
        exports: [UiCFilterReceiptComponent]
    })
], UiCFilterReceiptModule);

export { UiCFilterReceiptComponent, UiCFilterReceiptModule };
//# sourceMappingURL=wlp-ui-c-filter-receipt.js.map
